export interface ICommand { }

export class ApplyBrandingCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.OrganizationUnits.Commands.ApplyBrandingCommandV1, TCh.Domain.Organizations';

	Id: string;
	LogoBlobId: string;

	constructor (id: string, logoBlobId: string)
	{
		this.Id = id;
		this.LogoBlobId = logoBlobId;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.OrganizationUnits.Commands.ApplyBrandingCommandV1, TCh.Domain.Organizations'
	}

}

export class ConfigureOauth2CommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.OrganizationUnits.Commands.ConfigureOauth2CommandV1, TCh.Domain.Organizations';

	Id: string;
	ClientId: string;
	ClientSecret: string;
	TokenEndpointUri: string;
	AuthorizationEndpointUri: string;

	constructor (id: string, clientId: string, clientSecret: string, tokenEndpointUri: string, authorizationEndpointUri: string)
	{
		this.Id = id;
		this.ClientId = clientId;
		this.ClientSecret = clientSecret;
		this.TokenEndpointUri = tokenEndpointUri;
		this.AuthorizationEndpointUri = authorizationEndpointUri;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.OrganizationUnits.Commands.ConfigureOauth2CommandV1, TCh.Domain.Organizations'
	}

}

export class CreateOrganizationUnitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.OrganizationUnits.Commands.CreateOrganizationUnitCommandV1, TCh.Domain.Organizations';

	Id: string;
	Name: string;
	Description: string;

	constructor (id: string, name: string, description: string)
	{
		this.Id = id;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.OrganizationUnits.Commands.CreateOrganizationUnitCommandV1, TCh.Domain.Organizations'
	}

}

export class ResetBrandingCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.OrganizationUnits.Commands.ResetBrandingCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.OrganizationUnits.Commands.ResetBrandingCommandV1, TCh.Domain.Organizations'
	}

}

export class UpdateOrganizationUnitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.OrganizationUnits.Commands.UpdateOrganizationUnitCommandV1, TCh.Domain.Organizations';

	Id: string;
	Name: string;
	Description: string;

	constructor (id: string, name: string, description: string)
	{
		this.Id = id;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.OrganizationUnits.Commands.UpdateOrganizationUnitCommandV1, TCh.Domain.Organizations'
	}

}

